import { settingsResource } from '@/resources/settings_resource'
//
// eslint-disable-next-line
async function fetchSettings({commit}) {
  const response = await settingsResource.get()
  const settings = response.body
  // Django stores coordinates in reverse
  settings.map_centre.coordinates.reverse()
  commit('setSettings', { settings })
  return settings
}

export const actions = {
  fetchSettings,
}
